import { library } from '@fortawesome/fontawesome-svg-core'

import { 
    faAngleDoubleLeft,
    faAngleDoubleRight,
    faAngleDown,
    faAngleLeft,
    faAngleRight,
    faCalculator,
    faCaretDown,
    faCaretRight,
    faCaretUp,
    faChartLine,
    faCheck,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faCircle,
    faCircleNotch,
    faCog,
    faCogs,
    faCompass,
    faCrop,
    faDownload,
    faDrawPolygon,
    faEraser,
    faExclamationTriangle,
    faExpand,
    faFile,
    faFileDownload,
    faFileUpload,
    faFilter,
    faFont,
    faGripDotsVertical,
    faHourglassStart,
    faInfoCircle,
    faLayerGroup,
    faLeftRight,
    faListUl,
    faLocationArrow,
    faMapMarker,
    faMapMarkerAlt,
    faMapPin,
    faMinus,
    faMinusCircle,
    faMousePointer,
    faObjectGroup,
    faPalette,
    faPencilAlt,
    faPlus,
    faPlusCircle,
    faPrint,
    faRoute,
    faSearch,
    faSquare,
    faSync,
    faTable,
    faTimes,
    faTrashAlt,
    faTriangle,
    faUpDownLeftRight,
    faWrench
} from '@fortawesome/pro-solid-svg-icons'


library.add(
    faAngleDoubleLeft,
    faAngleDoubleRight,
    faAngleDown,
    faAngleLeft,
    faAngleRight,
    faCalculator,
    faCaretDown,
    faCaretRight,
    faCaretUp,
    faChartLine,
    faCheck,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faCircle,
    faCircleNotch,
    faCog,
    faCogs,
    faCompass,
    faCrop,
    faDownload,
    faDrawPolygon,
    faEraser,
    faExclamationTriangle,
    faExpand,
    faFile,
    faFileDownload,
    faFileUpload,
    faFilter,
    faFont,
    faGripDotsVertical,
    faHourglassStart,
    faInfoCircle,
    faLayerGroup,
    faLeftRight,
    faListUl,
    faLocationArrow,
    faMapMarker,
    faMapMarkerAlt,
    faMapPin,
    faMinus,
    faMinusCircle,
    faMousePointer,
    faObjectGroup,
    faPalette,
    faPencilAlt,
    faPlus,
    faPlusCircle,
    faPrint,
    faRoute,
    faSearch,
    faSquare,
    faSync,
    faTable,
    faTimes,
    faTrashAlt,
    faTriangle,
    faUpDownLeftRight,
    faWrench
);